import Box from "@mui/material/Box";
import { ReactNode } from "react";
import { useGetMaintenanceStatus } from "~/queries/use-get-maintenance-status";
import { MaintenanceBanner } from "~served/ui-comps/components/maintenance-banner";

export const MaintenanceLayout = ({ children }: { children: ReactNode }) => {
	const { data } = useGetMaintenanceStatus();
	const enabled = !!data?.enabled;
	return (
		<Box
			sx={{
				height: enabled ? "100vh" : undefined,
				display: "flex",
				flexDirection: "column",
			}}>
			{enabled && <MaintenanceBanner message={data.message} />}
			<Box
				data-maintenance-shell={enabled || undefined}
				sx={{
					flex: 1,
					minHeight: enabled ? 0 : "100vh",
					position: "relative",
					overflowY: enabled ? "auto" : undefined,
					"--app-shell-height": enabled ? "100%" : "100vh",
					"--app-drawer-position": enabled ? "absolute" : "fixed",
				}}>
				{children}
			</Box>
		</Box>
	);
};
